import React from "react";
import { Container } from "../../container/Styles/Wrappers";
import { CardGridWrapper } from "../Card/CardGridWrapper";
import Card from "../Card/Card";

function OtherSuggestions(props) {
  const { Meta } = Card;

  // FETCH OTHER SUGGESTIONS
  const otherSuggestions = [];

  return (
    <Container>
      <h1>Outras Sugestões</h1>
      <CardGridWrapper>
        {otherSuggestions.length > 0 &&
          otherSuggestions.map((element, index) => (
            <Card product={element} key={index}>
              {/* <RoomCardContent product={room} store={lodge} /> */}
              <h1>Teste</h1>
            </Card>

            // <Card
            //   hoverable
            //   style={{ width: 240 }}
            //   cover={
            //     <Carousel key={index}>
            //       {element.images?.map((im, index) => (
            //         <Image alt={im.alt} src={im.src} height={140} key={index} />
            //       ))}
            //     </Carousel>
            //   }
            //   key={index}
            // >
            //   <Meta
            //     title={element.name}
            //     description={element.description}
            //     style={{ marginBottom: 10 }}
            //     key={index}
            //   />
            // </Card>
          ))}
      </CardGridWrapper>
    </Container>
  );
}

export default OtherSuggestions;
